<template>
<div v-if="enableBtt" class="lottery-container" :class="{ 'overflow': resultVisible }">
  <div class="turntable-title">
    <img :src="titleImage" alt="">
  </div>
	<div class="turntable-container">
		<img :src="backgroundImage" alt="">
    <div class="prize-container">
      <div class="prize-item" v-for="(prize, index) in computedList" :key="index" @click="goLucky(prize.active)">
        <img :src="prize.img" alt="" class="prize">
        <img v-show="activepage === prize.active" :src="active" alt="" class="prize-active">
      </div>
    </div>
	</div>
  <van-dialog v-model="showGoods" :title="`恭喜获得${award}`" :beforeClose="beforeClose">
    <van-field
      v-model="address"
      rows="2"
      autosize
      label="地址"
      type="textarea"
      maxlength="50"
      placeholder="请输入地址"
      show-word-limit
    />
  </van-dialog>
  <van-dialog v-model="showPoints" :title="`恭喜获得${award}`">
  </van-dialog>
  <van-dialog v-model="showThanks" title="谢谢参与">
  </van-dialog>
</div>
</template>

<script>
import over from '@/assets/images/lottery/lottery-over.png'
import active from '@/assets/images/lottery/active.png'
import prizeCenter from '@/assets/images/lottery/center.png'
import { Toast, Dialog } from 'vant'
import { draw, saveAddress } from '@/api'

export default {
  name: 'Lottery',
  props: {
    phone: {
      type: [String, Number],
      default: ''
    },
    appType: {
      type: [String, Number],
      default: ''
    },
    backgroundImage: {
      type: String,
      default: ''
    },
    titleImage: {
      type: String,
      default: ''
    },
    actiBigturntableId: {
      type: [String, Number],
      default: ''
    },
    actiLargePostId: {
      type: [String, Number],
      default: ''
    },
    userName: {
      type: String,
      default: ''
    },
    enableBtt: {
      type: Number,
      default: 1
    },
    withRetention: {
      type: Number,
      default: 1
    },
    list: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      address: '',
      active,
	    resultVisible: false,
      activepage: '',
      activepagesList: ['top-left', 'top-center', 'top-right', 'center-right', 'bottom-right', 'bottom-center', 'bottom-left', 'center-left'],
      listData: [],
      award: null,
      over,
      prizeList: [],
      loading: false,
      showGoods: false,
      showPoints: false,
      showThanks: false
    }
  },
  computed: {
    computedList() {
      const resultType = (type) => {
        const data = {
          GOODS: 2,
          POINTS: 1,
          THX: 3
        }
        return data[type]
      }
      // 0-暂无机会，1-积分，2-实物，3-谢谢参与
      const arr = []
      if (this.list && this.list.length) {
        const UP_LEFT = this.list.find((v) => v.posi === 'UP_LEFT')
        if (UP_LEFT) {
          arr.push({
            code: UP_LEFT.actiGoodsId,
            active: 'top-left',
            img: UP_LEFT.gdsImgUrl,
            prizeImg: '',
            name: UP_LEFT.goodsName,
            index: 1,
            result: resultType(UP_LEFT.goodsType)
          })
        }
        const UP_CEN = this.list.find((v) => v.posi === 'UP_CEN')
        if (UP_CEN) {
          arr.push({
            code: UP_CEN.actiGoodsId,
            active: 'top-center',
            img: UP_CEN.gdsImgUrl,
            prizeImg: '',
            name: UP_CEN.goodsName,
            index: 2,
            result: resultType(UP_CEN.goodsType)
          })
        }
        const UP_RIGHT = this.list.find((v) => v.posi === 'UP_RIGHT')
        if (UP_RIGHT) {
          arr.push({
            code: UP_RIGHT.actiGoodsId,
            active: 'top-right',
            img: UP_RIGHT.gdsImgUrl,
            prizeImg: '',
            name: UP_RIGHT.goodsName,
            index: 3,
            result: resultType(UP_RIGHT.goodsType)
          })
        }
        const LEFT_CEN = this.list.find((v) => v.posi === 'LEFT_CEN')
        if (LEFT_CEN) {
          arr.push({
            code: LEFT_CEN.actiGoodsId,
            active: 'center-left',
            img: LEFT_CEN.gdsImgUrl,
            prizeImg: '',
            name: LEFT_CEN.goodsName,
            index: 8,
            result: resultType(LEFT_CEN.goodsType)
          })
        }
        arr.push({
          active: null,
          img: prizeCenter,
          prizeImg: '',
          index: 9
        })
        const RIGHT_CEN = this.list.find((v) => v.posi === 'RIGHT_CEN')
        if (RIGHT_CEN) {
          arr.push({
            code: RIGHT_CEN.actiGoodsId,
            active: 'center-right',
            img: RIGHT_CEN.gdsImgUrl,
            prizeImg: '',
            name: RIGHT_CEN.goodsName,
            index: 4,
            result: resultType(RIGHT_CEN.goodsType)
          })
        }
        const DOWN_LEFT = this.list.find((v) => v.posi === 'DOWN_LEFT')
        if (DOWN_LEFT) {
          arr.push({
            code: DOWN_LEFT.actiGoodsId,
            active: 'bottom-left',
            img: DOWN_LEFT.gdsImgUrl,
            prizeImg: '',
            name: DOWN_LEFT.goodsName,
            index: 7,
            result: resultType(DOWN_LEFT.goodsType)
          })
        }
        const DOWN_CEN = this.list.find((v) => v.posi === 'DOWN_CEN')
        if (DOWN_CEN) {
          arr.push({
            code: DOWN_CEN.actiGoodsId,
            active: 'bottom-center',
            img: DOWN_CEN.gdsImgUrl,
            prizeImg: '',
            name: DOWN_CEN.goodsName,
            index: 6,
            result: resultType(DOWN_CEN.goodsType)
          })
        }
        const DOWN_RIGHT = this.list.find((v) => v.posi === 'DOWN_RIGHT')
        if (DOWN_RIGHT) {
          arr.push({
            code: DOWN_RIGHT.actiGoodsId,
            active: 'bottom-right',
            img: DOWN_RIGHT.gdsImgUrl,
            prizeImg: '',
            name: DOWN_RIGHT.goodsName,
            index: 5,
            result: resultType(DOWN_RIGHT.goodsType)
          })
        }
      }
      return arr
    }
  },
  methods: {
    beforeClose(action, done) {
      if (!this.address) {
        Toast('请输入地址')
        done(false)
      } else {
        const params = {
          actiBigturntableId: this.actiBigturntableId,
          actiLargePostId: this.actiLargePostId,
          userAddr: this.address,
          userName: this.userName,
          userPhone: this.phone
        }
        saveAddress(params)
          .then(() => {
            done()
            Toast('保存成功')
          })
          .catch(() => {
            done(false)
          })
      }
    },
  	showResult(result) {
  	  // 0-暂无机会，1-积分，2-实物，3-谢谢参与
      if (result === 2) {
        this.showGoods = true
      }
      if (result === 1) {
        this.showPoints = true
      }
      if (result === 3) {
        this.showThanks = true
      }
	  },
    goLucky(prize) {
      this.award = null
  	  if (prize !== null) return
      if (this.withRetention && !this.phone) {
        if (this.actiLargePostId) {
          Toast('请先预约')
        }
        return
      }
      this.loading = true
      const params = {
        actiBigturntableId: this.actiBigturntableId,
        actiLargePostId: this.actiLargePostId,
        userName: this.userName,
        userPhone: this.phone
      }
      draw(params)
        .then((res) => {
          if (res.data.actiGoodsId) {
            const { index, result } = this.computedList.find((v) => v.code === res.data.actiGoodsId)
            this.award = res.data.goodsName
            this.goAward(index)
            setTimeout(() => {
              this.loading = false
              this.showResult(result)
            }, 5000)
          } else {
            Dialog.alert({
              message: '您已参与'
            }).then(() => {
              // on close
            })
          }
        })
        .catch((err) => {
          Toast(err.message || '遇到问题，请稍后再试')
        })
    },
    goAward(awardIndex) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < 3; i++) {
        // eslint-disable-next-line no-plusplus
        for (let j = 0; j < this.activepagesList.length; j++) {
          if (i === 2 && j === awardIndex) {
            return
          }
          // eslint-disable-next-line no-shadow
          ((j) => {
            setTimeout(() => {
              this.activepage = this.activepagesList[j]
            }, (j + 1) * 200 + (i) * 1600)
          })(j)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
$active-button-width: calc(100vw * 0.25);
$img-width: 100vw;
$space-width: 0;
img {
	display: block;
	max-width: 100%;
	&.img-absolute {
		position: absolute;
	}
}
p{
	margin: 0;
	padding: 0;
}
.lottery-container{
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	.lottery-top{
    position: relative;
		img{
			width: 100%;
		}
    .left-number{
      font-size: rem(28);
      color: #FFFFFF;
      position: absolute;
      width: 100%;
      text-align: center;
      bottom: rem(25);
    }
	}
	.turntable-container{
    img{
      width: $img-width;
      margin: 0 auto;
    }
    position: relative;
		.lottery-item{
			position: absolute;
			top: 0;
			left: $space-width;
		}
		.active-button{
			position: absolute;
			width: $active-button-width;
			height: $active-button-width;
			bottom: 39%;
			background: antiquewhite;
			left: 0;
			right: 0;
			margin: auto;
		}
    .prize-container{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      padding: 63 / 750 * 100vw 95 / 750 * 100vw 63 / 750 * 100vw 95 / 750 * 100vw;
      justify-content: space-between;
      align-content: space-between;
      .prize-item{
        width: 185 / 750 * 100vw;
        height: 185 / 750 * 100vw;
        flex-shrink: 0;
        flex-grow: 0;
        border-radius: rem(14);
        position: relative;
        display: flex;
        align-items: center;
        .prize{
          width: 95%;
          margin: 0 auto;
        }
      }
      .prize-active{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

      }
    }
	}
	.lottery-bottom{
		img{
			width: $img-width;
			margin: 0 auto;
		}
	}
}
</style>
